import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75bfd91a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Abonnements", -1))
const _hoisted_3 = { class: "item-container" }

import SubscriptionItemEditable from "./subscription-item-editable.vue";
import { subscriptionStorageModule } from "@/store/subscription-storage";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subscriptionStorageModule).getSubscriptions, (subscription) => {
        return (_openBlock(), _createBlock(SubscriptionItemEditable, {
          key: subscription.id,
          subscription: subscription
        }, null, 8, ["subscription"]))
      }), 128))
    ])
  ]))
}
}

})